import { EventEmitter } from "@angular/core";
import { DefaultLanguageChangeEvent, LanguageChangeEvent, LocalizationChangeEvent } from "./localizaton.model";

export class LocalizationHub {

  public defaultLanguage!: string;

  public currentLanguage: string = this.defaultLanguage;

  public localizations: any = {};

  public languages: Array<string> = [];

  public onLocalizationChange: EventEmitter<LocalizationChangeEvent> = new EventEmitter<LocalizationChangeEvent>();

  public onLanguageChange: EventEmitter<LanguageChangeEvent> = new EventEmitter<LanguageChangeEvent>();

  public onDefaultLanguageChange: EventEmitter<DefaultLanguageChangeEvent> = new EventEmitter<DefaultLanguageChangeEvent>();
}
